import type { Ref } from 'vue';
import { onMounted, onUnmounted, watch } from 'vue';
import type { Target } from '../../scripts/helpers/listeners/ClickOutsideListener';
import ClickOutsideListener from '../../scripts/helpers/listeners/ClickOutsideListener';
import type { Listener } from '../../scripts/helpers/listeners/ListenerProvider';

export const useClickOutsideListener = (
    enable: Ref<boolean>,
    targets: Target[],
    handler: Listener,
): void => {
    const listener = new ClickOutsideListener(targets, handler);

    onMounted(() => {
        if (enable.value) {
            listener.registerListener();
        }
    });

    onUnmounted(() => {
        if (enable.value) {
            listener.unregisterListener();
        }
    });

    watch(enable, (enabled) => {
        if (enabled) {
            listener.registerListener();
        } else {
            listener.unregisterListener();
        }
    });
};
